
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { IRect, IDictEntry, IDictEntryType } from '@/types';
import { Prop } from 'vue-property-decorator';
import Transcription from '../../store/modules/transcription';
import store from '@/store/store';

const trscModule = getModule(Transcription, store);
@Component
export default class DictEntryDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  @Prop(Object)
  data!: IDictEntry;
  share = true;

  items = [
    { text: '漢字（1字）', value: IDictEntryType.kanji },
    { text: 'かな（1字）', value: IDictEntryType.kana },
    { text: '語句', value: IDictEntryType.word },
    { text: 'その他', value: IDictEntryType.other },
  ];
  selected = this.items[0];
  text = '';
  comment = '';

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit('input', value);
  }

  init() {
    this.text = '';
    this.comment = '';
  }

  async save() {
    this.show = false;
    //return await trscModule.saveDictEntry({ entry: this.data });
  }

  remove() {
    this.show = false;
  }

  cancel() {
    this.show = false;
  }
}
